import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from "vue-router";
import QuestionnaireLogin from "@/views/Questionnaire/Auth/QuestionnaireLogin.vue";
import QuestionnaireResetPassword from "@/views/Questionnaire/Auth/QuestionnaireResetPassword.vue";
import QuestionnaireNewPassword from "@/views/Questionnaire/Auth/QuestionnaireNewPassword.vue";
import QuestionnaireParent from "@/views/Questionnaire/QuestionnaireParent.vue";
import QuestionnaireGeneralError from "@/views/Questionnaire/QuestionnaireGeneralError.vue";
import QuestionnaireSetPassword from "@/views/Questionnaire/Auth/QuestionnaireSetPassword.vue";
import { commonRoute } from "@/router/portal";
import { QUESTIONNAIRE_ACCEPT_CALLBACK_URLS, QuestionnaireRouteNames } from "@/commons/questionnaire/questionnaire";


// アンケートシステム画面用ルート定義
const routes = [
    {
        path: "/questionnaire",
        name: QuestionnaireRouteNames.PARENT,
        component: QuestionnaireParent,
        props: {
            acceptCallbackUrls: QUESTIONNAIRE_ACCEPT_CALLBACK_URLS,
        },
        children: [
            {
                path: "login",
                name: QuestionnaireRouteNames.LOGIN,
                component: QuestionnaireLogin,
                meta: { title: "ログイン" },
                props: true
            },
            {
                path: "new_password",
                name: QuestionnaireRouteNames.NEW_PASSWORD,
                component: QuestionnaireNewPassword,
                meta: { title: "新規パスワード設定" },
                beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
                    if (!from.name) {
                        next({ name: QuestionnaireRouteNames.LOGIN });
                    } else {
                        next();
                    }
                },
            },
            {
                path: "reset_password",
                name: QuestionnaireRouteNames.RESET_PASSWORD,
                component: QuestionnaireResetPassword,
                meta: { title: "パスワードリセット" },
            },
            {
                path: "set_password",
                name: QuestionnaireRouteNames.SET_PASSWORD,
                component: QuestionnaireSetPassword,
                meta: { title: "パスワード再設定" },
            },
            {
                path: "error",
                name: QuestionnaireRouteNames.GENERAL_ERROR,
                component: QuestionnaireGeneralError,
                meta: { title: "エラー" },
                props: true
            },
        ]
    },
    // 共通のルート定義（ポータルとパスを合わせることで整合させる）
    ...commonRoute,
    {
        path: "/:catchAll(.*)",
        redirect: () => {
            return { name: QuestionnaireRouteNames.GENERAL_ERROR };
        }
    },
];

// アンケートシステム画面用スクロール設定
const questionnaireScrollBehavior = async (to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, savedPosition: any) => {
    if (savedPosition) {
        return savedPosition;
    } else if (to.hash) {
        return { el: to.hash, behavior: "smooth" };
    } else {
        return { left: 0, top: 0 };
    }
};

/** アンケートシステム画面用ルータ */
export const questionnaireRouter = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: questionnaireScrollBehavior,
    routes,
});
